module.exports = __webpack_public_path__ + "img/laptop_chromebook.b574dfa7.svg";